import React, { Fragment } from 'react';
import Button from '../../../../components/Button';
import BaseForm from '../../../../components/form/BaseForm';
import {
  TAG_TAB_MAIN_MANAGEMENT_URL_PATH,
  TAG_TREND_KEYWORD_MANAGEMENT_URL_PATH,
} from '../../../../constants/service/common/urlConstants';
import { openNewWindow, setNumberWithComma } from '../../../../lib/common';
import { setTagUsedCheckText } from '../../../../lib/utils/tagUtils';
import './TagHistoryActivityHistory.scss';

const TagHistoryActivityHistory = (props) => {
  const { activityHistory } = props;
  const {
    userFollowerCount,
    clickCount,
    searchCount,
    isUsedTagTabMainTrendKeywordList,
    isUsedTagTabMainSelectedFollowList,
    isUsedTagTrendKeywordTopRankList,
    isUsedTagTrendKeywordStyleList,
    isUsedTagTrendKeywordCollectionList,
  } = activityHistory;

  return (
    <div className="tag-history-content tag-history-activity-history">
      {/* 유저 태그 팔로워 수 */}
      <BaseForm label="유저 태그 팔로워 수" content={setNumberWithComma(userFollowerCount, '개')} />

      {/* 클릭 수 (조회) */}
      <BaseForm label="클릭 수 (조회)" content={setNumberWithComma(clickCount, '개')} />

      {/* 검색 수 (조회) */}
      <BaseForm label="검색 수 (조회)" content={setNumberWithComma(searchCount, '개')} />

      {/* 태그 메인 탭 트렌드 키워드 리스트 노출 여부 */}
      <BaseForm
        label={
          <div>
            <div>태그 메인 탭 트렌드</div>
            <div>키워드 리스트 노출 여부</div>
          </div>
        }
        className="is-used-check-form"
        content={
          <Fragment>
            <span className="is-used-check-value">{setTagUsedCheckText(isUsedTagTabMainTrendKeywordList)}</span>

            <Button
              color="primary"
              isRadius={true}
              text="태그 메인 탭 관리로 이동"
              onClick={() => openNewWindow(TAG_TAB_MAIN_MANAGEMENT_URL_PATH)}
            />
          </Fragment>
        }
      />

      {/* 태그 메인 탭 팔로우한 리스트 노출 여부 */}
      <BaseForm
        label={
          <div>
            <div>태그 메인 탭 트렌드</div>
            <div>팔로우한 리스트 노출 여부</div>
          </div>
        }
        className="is-used-check-form"
        content={
          <Fragment>
            <span className="is-used-check-value">{setTagUsedCheckText(isUsedTagTabMainSelectedFollowList)}</span>

            <Button
              color="primary"
              isRadius={true}
              text="태그 메인 탭 관리로 이동"
              onClick={() => openNewWindow(TAG_TAB_MAIN_MANAGEMENT_URL_PATH)}
            />
          </Fragment>
        }
      />

      {/* 태그 트렌드 키워드 top 30 추천 노출 여부 */}
      <BaseForm
        label={
          <div>
            <div>태그 트렌드 키워드</div>
            <div>top 30 노출 여부</div>
          </div>
        }
        className="is-used-check-form"
        content={
          <Fragment>
            <span className="is-used-check-value">{setTagUsedCheckText(isUsedTagTrendKeywordTopRankList)}</span>

            <Button
              color="primary"
              isRadius={true}
              text="태그 트렌드 키워드 관리로 이동"
              onClick={() => openNewWindow(TAG_TREND_KEYWORD_MANAGEMENT_URL_PATH)}
            />
          </Fragment>
        }
      />

      {/* 태그 트렌드 키워드 스타일별 추천 노출 여부 */}
      <BaseForm
        label={
          <div>
            <div>태그 트렌드 키워드</div>
            <div>스타일별 노출 여부</div>
          </div>
        }
        className="is-used-check-form"
        content={
          <Fragment>
            <span className="is-used-check-value">{setTagUsedCheckText(isUsedTagTrendKeywordStyleList)}</span>

            <Button
              color="primary"
              isRadius={true}
              text="태그 트렌드 키워드 관리로 이동"
              onClick={() => openNewWindow(TAG_TREND_KEYWORD_MANAGEMENT_URL_PATH)}
            />
          </Fragment>
        }
      />

      {/* 태그 트렌드 키워드 태그모아보기 추천 노출 여부 */}
      <BaseForm
        label={
          <div>
            <div>태그 트렌드 키워드</div>
            <div>태그모아보기 노출 여부</div>
          </div>
        }
        className="is-used-check-form"
        content={
          <Fragment>
            <span className="is-used-check-value">{setTagUsedCheckText(isUsedTagTrendKeywordCollectionList)}</span>

            <Button
              color="primary"
              isRadius={true}
              text="태그 트렌드 키워드 관리로 이동"
              onClick={() => openNewWindow(TAG_TREND_KEYWORD_MANAGEMENT_URL_PATH)}
            />
          </Fragment>
        }
      />
    </div>
  );
};

export default TagHistoryActivityHistory;
